'use es6';

import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import React from 'react';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIconRating from 'UIComponents/input/UIIconRating';
import UISection from 'UIComponents/section/UISection';
import UITextArea from 'UIComponents/input/UITextArea';
import Small from 'UIComponents/elements/Small';
import HubspotUrls from '../constants/HubspotUrls';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import ReviewerInfo from './ReviewerInfo';
import SaveButton from './SaveButton';
import { getButtonState } from '../utils/utils';
import { getCharactersRemainingText } from '../utils/langUtils';
var ENTER = 13;
var MAX_CHARACTERS = 300;
export default createReactClass({
  displayName: "ReviewInput",
  propTypes: {
    currentUserEmail: PropTypes.string.isRequired,
    currentUserFullName: PropTypes.string.isRequired,
    goodId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    parentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    pageOpenedFrom: PropTypes.string.isRequired,
    submitReviewStatus: PropTypes.string.isRequired,
    submitReview: PropTypes.func.isRequired,
    transactionId: PropTypes.number
  },
  getInitialState: function getInitialState() {
    return {
      rating: 0,
      reviewText: ''
    };
  },
  handleReviewTextUpdate: function handleReviewTextUpdate(event) {
    if (event.target.value.length <= MAX_CHARACTERS) {
      this.setState({
        reviewText: event.target.value
      });
    }
  },
  isValidReview: function isValidReview() {
    return this.state.rating > 0 && this.state.reviewText.length > 0;
  },
  onRatingClick: function onRatingClick(event) {
    this.setState({
      rating: event.target.value
    });
  },
  onClickSubmit: function onClickSubmit() {
    var _this$props = this.props,
        goodId = _this$props.goodId,
        parentId = _this$props.parentId,
        pageOpenedFrom = _this$props.pageOpenedFrom,
        submitReview = _this$props.submitReview,
        transactionId = _this$props.transactionId;
    submitReview(goodId, transactionId, this.state.rating, this.state.reviewText, pageOpenedFrom, parentId);
  },
  preventEnter: function preventEnter(event) {
    if (event.keyCode === ENTER) {
      event.preventDefault();
    }
  },
  renderErrorAlert: function renderErrorAlert() {
    if (this.props.submitReviewStatus === RequestStatusTypes.FAILED) {
      return React.createElement(UISection, null, React.createElement(UIAlert, {
        titleText: I18n.text('reviewModal.submitError.header'),
        type: "danger"
      }, React.createElement(FormattedHTMLMessage, {
        message: "reviewModal.submitError.description"
      })));
    }

    return null;
  },
  render: function render() {
    var _this$props2 = this.props,
        currentUserEmail = _this$props2.currentUserEmail,
        currentUserFullName = _this$props2.currentUserFullName,
        submitReviewStatus = _this$props2.submitReviewStatus;
    return React.createElement("div", {
      className: "integrate-review-input"
    }, React.createElement(UISection, null, React.createElement(UIFlex, {
      justify: "between"
    }, React.createElement("strong", null, I18n.text('reviewModal.review')), React.createElement(UIIconRating, {
      onChange: this.onRatingClick,
      size: "xxs"
    })), React.createElement(UITextArea, {
      className: "text-area-resize-vertical",
      rows: 6,
      placeholder: I18n.text('reviewModal.commentPlaceholder'),
      onChange: this.handleReviewTextUpdate,
      onKeyDown: this.preventEnter,
      value: this.state.reviewText
    }), React.createElement(Small, {
      className: "text-right",
      tagName: "p",
      use: "help"
    }, getCharactersRemainingText(MAX_CHARACTERS, this.state.reviewText.length)), React.createElement(ReviewerInfo, {
      userEmail: currentUserEmail,
      userFullName: currentUserFullName
    })), this.renderErrorAlert(), React.createElement(UISection, {
      className: "m-bottom-10"
    }, React.createElement("p", null, React.createElement(Small, {
      use: "help"
    }, React.createElement(FormattedHTMLMessage, {
      message: "reviewModal.legalAgreement",
      options: {
        reviewGuidelinesLink: HubspotUrls.REVIEW_GUIDELINES,
        termsOfUseLink: HubspotUrls.TERMS_OF_USE
      }
    }))), React.createElement(SaveButton, {
      buttonState: getButtonState(submitReviewStatus),
      disabled: !this.isValidReview() || submitReviewStatus === RequestStatusTypes.PENDING,
      onClick: this.onClickSubmit,
      textPath: "reviewModal"
    })));
  }
});